import { colors, Grid, GridItem, Typography } from '@ui-components/neo.tax';
import React from 'react';

import { useCreditEstimate } from '@neo.tax/rd/hooks';
import { FilingMethod, useCurrentUserScopeForCurrentCompany } from '@neo.tax/shared';

import { CreditCalculationEstimateSection } from './CreditCalculationEstimateSection';

const FILING_METHOD_LABELS: Record<FilingMethod, string> = {
  [FilingMethod.Asc]: 'ASC',
  [FilingMethod.Regular]: 'REGULAR',
};

interface CreditCalculationEstimateProps {
  filingMethod: FilingMethod | undefined;
}

export const CreditCalculationEstimate = ({ filingMethod }: CreditCalculationEstimateProps): React.ReactElement => {
  const { limitAccessToFinancialData } = useCurrentUserScopeForCurrentCompany();
  const { form6765Values } = useCreditEstimate();
  const creditCents =
    filingMethod === FilingMethod.Asc ? form6765Values?.ascMethodCreditCents : form6765Values?.regularMethodCreditCents;

  if (limitAccessToFinancialData) {
    return <></>;
  }

  return (
    <Grid cols={4} gap={2} className="max-w-7xl">
      <GridItem size={2}>
        <CreditCalculationEstimateSection
          backgroundColor={colors.green[300]}
          title="Estimated Credit Amount"
          amountCents={creditCents}
          suffix={
            <Typography as="p" fontFamily="sans" fontWeight="medium" fontSize="xs" color={colors.white}>
              {filingMethod ? FILING_METHOD_LABELS[filingMethod] : ''}
            </Typography>
          }
        />
      </GridItem>
      <GridItem size={2}>
        <CreditCalculationEstimateSection
          backgroundColor={colors.white}
          title="Total QREs"
          amountCents={form6765Values?.totalQreCents}
        />
      </GridItem>
      <GridItem size={1}>
        <CreditCalculationEstimateSection
          backgroundColor={colors.gray[50]}
          title="Wages QREs"
          amountCents={form6765Values?.wagesQreCents}
        />
      </GridItem>
      <GridItem size={1}>
        <CreditCalculationEstimateSection
          backgroundColor={colors.gray[50]}
          title="Contractor QREs"
          amountCents={form6765Values?.contractorQreCents}
        />
      </GridItem>
      <GridItem size={1}>
        <CreditCalculationEstimateSection
          backgroundColor={colors.gray[50]}
          title="Cloud QREs"
          amountCents={form6765Values?.cloudQreCents}
        />
      </GridItem>
      <GridItem size={1}>
        <CreditCalculationEstimateSection
          backgroundColor={colors.gray[50]}
          title="Supplies QREs"
          amountCents={form6765Values?.suppliesQreCents}
        />
      </GridItem>
    </Grid>
  );
};
